module.exports = __webpack_public_path__ + "static/media/gif.77fda32e.gif";